import * as yup from 'yup'
import 'yup-phone'
import { verticals } from '../utils/verticals'
const phoneRegExp =
  /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/

export const editInfluencerFormValidationSchema = yup.object().shape({
  screenName: yup.string().required('Required'),
  profilePhoto: yup.string().required('Required'),
  name: yup.string().required('Required'),
  mobile: yup
    .string()
    .required('Required')
    .phone('', true, 'Invalid phone number')
    .matches(phoneRegExp, 'Invalid phone number'),
  email: yup.string().email('Invalid email').required('Required'),
  birthday: yup.string().required('Required'),
  address: yup
    .string()
    .test(
      'isCompleteAddress',
      'Missing address field values',
      value => value.split(', ').length === 4
    )
    .required('Required'),
  postalCode: yup.string().required('Required'),
  addressLine: yup.string().required('Required'),
  sameAsShipping: yup.boolean().required('Required'),
  shippingAddress: yup.string().when('sameAsShipping', {
    is: true,
    then: yup.string(),
    otherwise: yup.string().required('Required')
  }),
  verticals: yup
    .object(
      verticals.reduce((ac, item) => {
        ac[item] = yup.boolean().nullable()
        return ac
      }, {})
    )
    .test('checkedTest', 'Select at least one vertical', verticals =>
      Object.values(verticals).includes(true)
    ),
  bankAccountName: yup.string().required('Required'),
  bankAccountNumber: yup
    .string()
    .test('type', 'Must only contain numbers', value => !isNaN(value))
    .required('Required'),
  bank: yup.string().required('Required'),
  tin: yup
    .string()
    .test('type', 'Must only contain numbers', value => !isNaN(value)),
  manager: yup.string(),
  fb: yup.string(),
  ig: yup.string(),
  ty: yup.string(),
  tw: yup.string(),
  tiktok: yup.string()
})

export const registerInfluencerFormValidationSchema = yup.object().shape({
  screenName: yup.string().required('Required'),
  profilePhoto: yup.string().required('Required'),
  name: yup.string().required('Required'),
  mobile: yup
    .string()
    .required('Required')
    .phone('', true, 'Invalid phone number')
    .matches(phoneRegExp, 'Invalid phone number'),
  email: yup.string().email('Invalid email').required('Required'),
  emailConfirm: yup
    .string()
    .email('Invalid email')
    .required('Required')
    .oneOf([yup.ref('email'), null], 'Emails must match'),
  birthday: yup.string().required('Required'),
  address: yup
    .string()
    .test(
      'isCompleteAddress',
      'Missing address field values',
      value => value.split(', ').length === 4
    )
    .required('Required'),
  postalCode: yup.string().required('Required'),
  addressLine: yup.string().required('Required'),
  sameAsShipping: yup.boolean().required('Required'),
  shippingAddress: yup.string().when('sameAsShipping', {
    is: true,
    then: yup.string(),
    otherwise: yup.string().required('Required')
  }),
  verticals: yup
    .object(
      verticals.reduce((ac, item) => {
        ac[item] = yup.boolean().nullable()
        return ac
      }, {})
    )
    .test('checkedTest', 'Select at least one vertical', verticals =>
      Object.values(verticals).includes(true)
    ),
  bankAccountName: yup.string().required('Required'),
  bankAccountNumber: yup
    .string()
    .test('type', 'Must only contain numbers', value => !isNaN(value))
    .required('Required'),
  bank: yup.string().required('Required'),
  tin: yup
    .string()
    .test('type', 'Must only contain numbers', value => !isNaN(value)),
  manager: yup.string(),
  fb: yup.string(),
  ig: yup.string(),
  ty: yup.string(),
  tw: yup.string(),
  tiktok: yup.string()
})
